<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Compass" class="d-icon d-icon--compass" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 6a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0ZM7.962 3.405a.5.5 0 0 1 .633.633l-.903 2.705a1.502 1.502 0 0 1-.949.95l-2.705.9a.5.5 0 0 1-.633-.631l.903-2.706a1.5 1.5 0 0 1 .949-.948l2.705-.903Zm-2.39 1.85a.501.501 0 0 0-.315.317h-.001L4.67 7.328l1.758-.585a.5.5 0 0 0 .316-.315v-.001L7.33 4.67l-1.757.586ZM11.5 6a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconCompass',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
